
export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/packaging`,
        name: `${prefix}.accounts.packaging.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.packaging.index`,
                PageDescription: "Accounts master data: Packaging",
            },
        },
    },
];
